export default __webpack_public_path__ + "static/media/money-bag.2a33b11b.png";